let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1c7rv")).then(() => parcelRequire('dZrxI'));